import { registerFunctionalComponent } from 'js/lib/components/component'
import { createAnalyticsGroup } from 'js/lib/analytics'

registerFunctionalComponent('.js-c-logo--partner', 'PartnerLogoBaseComponent', (component) => {
  const currentPage = window.location.href
  const partnerKey = component.element.getAttribute('data-tracking')
  
  const track = createAnalyticsGroup(`partner-logo--${partnerKey}`)
  
  component.useHandler(() => {
    const handleClick = () => {
      const partnerName = partnerKey.replace(/[_-]/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
      track('click', `${partnerName} logo from ${currentPage}`)
    }
    
    const linkElement = component.element.querySelector('a')
    if (linkElement) {
      linkElement.addEventListener('click', handleClick)
      return () => linkElement.removeEventListener('click', handleClick)
    }
  })
})
